<template>
  <v-form ref="FormGenerator" v-model="valid" lazy-validation v-if="render">
    <slot name="title" v-if="title">{{ title }}</slot>

    <v-row class="no-gutters">
      <template v-for="(item, index) in config">
        <form-field
          v-if="item.type.toLowerCase() != 'group'"
          v-model="formData[item.name]"
          :item="item"
          :key="index"
          :value="item.default ? item.default : null"
        ></form-field>

        <v-col
          :key="index"
          :md="item.layout || 12"
          v-if="item.type.toLowerCase() == 'group'"
        >
          <v-expansion-panels
            v-model="panels[item.name]"
            accordion
            flat
            class="form-panel"
          >
            <v-expansion-panel>
              <v-expansion-panel-header class="px-2 bg-primary"
                ><h3>{{ item.label }}</h3>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="my-2">
                  <template v-for="(item, index) in item.form">
                    <form-field
                      v-if="item.type.toLowerCase() != 'group'"
                      v-model="formData[item.name]"
                      :item="item"
                      :key="index"
                    ></form-field>
                  </template>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </template>
    </v-row>
    <slot></slot>
  </v-form>
</template>

<script>
import FormField from "./FormField.vue";
export default {
  name: "FormBuilder",
  props: {
    value: {
      type: Object,
    },
    name: {
      type: String,
      default: "New Form",
    },
    title: {
      type: String,
      default: null,
    },
    config: {
      type: Array,
    },
    lazy: {
      // if set to false will automatically update v-model without submit
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    render: {
      // indicator if form is mounted or not
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormField,
  },
  data() {
    return {
      date: {
        menu: [],
        model: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      },
      valid: true,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      country: {
        search: "",
        items: [
          "Afghanistan",
          "Albania",
          "Algeria",
          "Andorra",
          "Angola",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Australia",
          "Austria",
          "Azerbaijan",
          "The Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bhutan",
          "Bolivia",
          "Bosnia and Herzegovina",
          "Botswana",
          "Brazil",
          "Brunei",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cabo Verde",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Central African Republic",
          "Chad",
          "Chile",
          "China",
          "Colombia",
          "Comoros",
          "Congo, Democratic Republic of the",
          "Congo, Republic of the",
          "Costa Rica",
          "Côte d’Ivoire",
          "Croatia",
          "Cuba",
          "Cyprus",
          "Czech Republic",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic",
          "East Timor (Timor-Leste)",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Eswatini",
          "Ethiopia",
          "Fiji",
          "Finland",
          "France",
          "Gabon",
          "The Gambia",
          "Georgia",
          "Germany",
          "Ghana",
          "Greece",
          "Grenada",
          "Guatemala",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Honduras",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran",
          "Iraq",
          "Ireland",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea, North",
          "Korea, South",
          "Kosovo",
          "Kuwait",
          "Kyrgyzstan",
          "Laos",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands",
          "Mauritania",
          "Mauritius",
          "Mexico",
          "Micronesia, Federated States of",
          "Moldova",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Morocco",
          "Mozambique",
          "Myanmar (Burma)",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Zealand",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "North Macedonia",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Poland",
          "Portugal",
          "Qatar",
          "Romania",
          "Russia",
          "Rwanda",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "Spain",
          "Sri Lanka",
          "Sudan",
          "Sudan, South",
          "Suriname",
          "Sweden",
          "Switzerland",
          "Syria",
          "Taiwan",
          "Tajikistan",
          "Tanzania",
          "Thailand",
          "Togo",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates",
          "United Kingdom",
          "United States",
          "Uruguay",
          "Uzbekistan",
          "Vanuatu",
          "Vatican City",
          "Venezuela",
          "Vietnam",
          "Yemen",
          "Zambia",
          "Zimbabwe",
        ],
      },
      formData: {},
      panels: {}, // expansion panels if
    };
  },
  computed: {
    formRef() {
      return this.name.replace(" ", "_");
    },
  },
  watch: {
    formData: {
      // if lazy is set to false it will update v-model right away
      deep: true,
      handler() {
        if (!this.lazy) {
          //console.log("update", this.formData);
          this.$emit("input", this.formData);
        }
      },
    },
    value: {
      deep: true,
      handler(newVal) {
        this.formData = Object.assign(this.formData, newVal);
      },
    },
    render(newVal) {
      if (!newVal) {
        this.$nextTick(() => this.resetValidation());
      }
    },
  },
  methods: {
    _options(string) {
      //converts csv to array
      string = string.split(",");
      return string.map((item) => item.trim());
    },
    validate() {
      //this.$refs[this.formRef].validate();
      this.$refs["FormGenerator"].validate();
    },
    reset() {
      let form = this.$refs["FormGenerator"];
      if (form) {
        form.reset();
      }
      // this.$refs[this.formRef].reset();
    },
    resetValidation() {
      let form = this.$refs["FormGenerator"];
      if (form) {
        form.reset();
      }
    },
    submit() {
      console.log("formData", this.formData);
      this.$emit("submit", this.formData);
      this.$emit("input", this.formData);
    },
    closeAllPanels() {
      let panels = this.panels;
      panels = Object.keys(panels).map((item) => (panels[item] = null));
    },
    init() {
      console.log("init");
      let config = this.config;
      // converts config array to an object using the .name key
      this.formData = config.reduce(
        (obj, item) => Object.assign(obj, { [item.name]: null }),
        {}
      );
      Object.keys(this.formData).forEach(
        (item) => (this.formData[item] = this.value[item])
      );
      console.log("formData", this.formData);
      let _panels = this.config.filter(
        (item) => item.type.toLowerCase() == "group"
      );
      //console.log("_panels", _panels);
      this.panels = _panels.reduce(
        (obj, item) => Object.assign(obj, { [item.name]: null }),
        {}
      );

      //this.resetValidation();
      //console.log("this.panels", this.panels);
    },
  },
  mounted() {
    this.init();
    console.log("form generator regular mounted", this.value);
  },
};
</script>

<style lang="scss">
// // Fixes Autofill color
// input:-webkit-autofill,
// input:-webkit-autofill:hover,
// input:-webkit-autofill:focus textarea:-webkit-autofill,
// textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
// select:-webkit-autofill,
// select:-webkit-autofill:hover,
// select:-webkit-autofill:focus {
//   -webkit-box-shadow: 0 0 0px 30px #1f2631 inset !important;
//   -webkit-text-fill-color: #ffffff;
// }

.form-panel {
  border-radius: 0 !important;
  .v-expansion-panel-header {
    background: #d1d1d1;
    min-height: max-content !important;

    h3 {
      font-weight: 500 !important;
    }

    &.v-expansion-panel-header--active {
      background: #e4e4e4;
      color: rgba(0, 0, 0, 0.6);
      h3 {
        font-weight: 500 !important;
      }
    }
  }
}
</style>
